import service from '../utils/request'
// 查询续费列表
export const GetSkipSummary = params => {return service.post(`/api/order/GetSkipSummary`, params)};
// 收银日报
export const Getsaledaily = params => {return service.post(`/api/order/Getsaledaily`, params)};
// 收银日报汇总
export const Getsaledailysummary = params => {return service.post(`/api/order/Getsaledailysummary`, params)};
// 销售订单
export const getorderrecord = params => {return service.post(`/api/order/getweborderrecord`, params)};


// 首页数据
export const gethomedata = params => {return service.post(`/api/order/gethomedata`, params)};
// 根据ID获取详情
export const getpaylistbyorderid = params => {return service.get(`/api/order/getpaylistbyorderid`, {params: params})};
// 收银日报
export const getsectionsummary = params => {return service.post(`/api/order/getsectionsummary`, params)};
// 查询续费列表
export const GetPaydetailRecord = params => {return service.post(`/api/order/GetPaydetailRecord`, params)};
//订单退款
export const retutnamountbyid = params => {return service.post(`/api/order/retutnamountbyid`, params)};
// 查询退款信息
export const refundresultquery = params => { return service.get(`/api/order/refundresultquery`, { params }) };
// 根据ID获取详情
export const GetOrderById = params => {return service.get(`/api/order/GetOrderById`, {params: params})};
// 出场操作
export const CarOut = params => {return service.post(`/api/order/CarOut`, params)};
//修改入场时间
export const editcarin = params => {return service.post(`/api/order/editcarin`, params)};

// 重置为跑单
export const resetorderbyid = params => { return service.get(`/api/order/resetorderbyid`, { params }) };

//批量删除
export const bulkdelete = params => {return service.post(`/api/order/bulkdelete`, params)};

